import { render } from "./peppolIdentifierSelector.vue?vue&type=template&id=41367514&scoped=true"
import script from "./peppolIdentifierSelector.vue?vue&type=script&lang=js"
export * from "./peppolIdentifierSelector.vue?vue&type=script&lang=js"

import "./peppolIdentifierSelector.vue?vue&type=style&index=0&id=41367514&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41367514"]])

export default __exports__